<template>
  <div
    v-else
    class="white d-flex align-center flex-column justify-center py-7 px-10 fill-height"
    v-resize="onResize"
  >
    <span class="headline font-weight-light text-center mb-10">
      Ups. No encontramos la pagina a la estás intentando acceder.
    </span>
    <span class="display-3 font-weight-bold primary--text text-center mb-4">
      404
    </span>
    <div>
      <v-img src="@/assets/404.svg" contain :height="windowSize.y - 350"></v-img>
    </div>
    <div class="mt-8">
      <BaseMyButton
        :borderRadius="100"
        :to="{ name: 'home' }"
      >
        Volver al inicio
      </BaseMyButton>
    </div>
  </div>
</template>

<script>
  import { windowSizeMixin } from "@/mixin/windowSizeMixin.js";
  
  export default {
    mixins: [windowSizeMixin]
  }
</script>